'use client';

import { useState } from 'react';
import { Icon } from '@/app_components/common/Icon';
import { SocialLinksDropdown } from '@/app_components/common/SocialLinksDropdown';

interface BottomShareProps {
  title: string;
}

export const BottomShare = ({ title }: BottomShareProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const trigger = (
    <button
      className='flex px-6 py-3 items-center gap-2 rounded-full button-secondary button-secondary-hover'
      data-cy='ez-newswire-content-page-bottom-share-button'
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      type='button'
    >
      <div className='text-base leading-4 font-medium'>Share</div>
      <Icon
        className='w-[18px] h-4'
        icon='Share2'
      />
    </button>
  );

  return (
    <div
      className='flex justify-between items-center max-lg:pb-4 max-lg:border-b max-lg:stroke-secondary font-graphik-compact text-primary'
      data-cy='ez-newswire-content-page-bottom-share'
    >
      <div
        className='typography-level-2 font-semibold'
        data-cy='ez-newswire-content-page-bottom-share-text'
      >
        Share this article
      </div>
      <SocialLinksDropdown
        contentClassName='mt-0 ml-[48px]'
        isShareButtonHovered={isOpen}
        title={title}
        trigger={trigger}
      />
    </div>
  );
};
